import { useState, useEffect, useRef } from 'react';

const useShowTooltip = () => {
	const [showTooltip, setShowTooltip] = useState(false);
	const domRef = useRef(null);

	useEffect(() => {
		const { current } = domRef;

		const checkShowTooltip = () => {
			// Show tooltip only when ellipsis is required
			if (current) {
				if (current.offsetWidth < current.scrollWidth) {
					setShowTooltip(true);
				} else {
					setShowTooltip(false);
				}
			}
		};

		checkShowTooltip();
	}, []);

	return [showTooltip, domRef];
};

export default useShowTooltip;
